import { COUNTRY_ISO } from '@/constants/countries';

let lastSdk = '';

const CLIENT_ID = {
  [COUNTRY_ISO.AUSTRALIA]: process.env.VUE_APP_PAYPAL_CLIENT_ID_AUSTRALIA,
  [COUNTRY_ISO.CANADA]: process.env.VUE_APP_PAYPAL_CLIENT_ID_CANADA,
  [COUNTRY_ISO.FRANCE]: process.env.VUE_APP_PAYPAL_CLIENT_ID_FRANCE,
  [COUNTRY_ISO.GREAT_BRITAIN]: process.env.VUE_APP_PAYPAL_CLIENT_ID_GREAT_BRITAIN,
  [COUNTRY_ISO.UNITED_STATES]: process.env.VUE_APP_PAYPAL_CLIENT_ID_CANADA
};

export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$getPayPal = ({ country, currency }) =>
      new Promise(resolve => {
        const clientId = CLIENT_ID[country.toUpperCase()] || CLIENT_ID[COUNTRY_ISO.FRANCE];
        const src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${currency}`;

        if (lastSdk === src && window.paypal) {
          resolve(window.paypal);

          return;
        }

        lastSdk = src;

        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', () => {
          resolve(window.paypal);
        });
        document.documentElement.append(script);
      });
  }
};
